export enum ErrorTypeEnum {
    API_ERROR = 'API_ERROR',
    NO_ROLES = 'NO_ROLES',
}
